module.exports = __webpack_public_path__ + "img/pet_camera_pairing_mode.b28a9b6f.png";